var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",staticClass:"tkStickyItem_wrapper",style:({
    '--top': `${_vm.top}px`,
    '--z-index': _vm.zIndex,
  })},[_vm._t("default",null,{"isPinned":_vm.isPinned})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }